module.exports = __webpack_public_path__ + "img/email-action-remove.e993766d.svg";